import { render, staticRenderFns } from "./fccRelatoriosCadastro.vue?vue&type=template&id=3f80a55d"
import script from "./fccRelatoriosCadastro.vue?vue&type=script&lang=js"
export * from "./fccRelatoriosCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports